import { render } from "./promociones.vue?vue&type=template&id=f8226722"
import script from "./promociones.vue?vue&type=script&lang=js"
export * from "./promociones.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__